import { ICreateCentroCustoSecundarioUseCase } from "../../../presentation/useCases/create/create_centro_custo_secundario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateCentroCustoSecundarioUseCase
 */

export class CreateCentroCustoSecundarioUseCase implements ICreateCentroCustoSecundarioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createCentroCustoSecundario(
    idFuncionario: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.repository.createCentroCustoSecundario(
      idFuncionario,
      idCentroCusto,
    );
  }
}